// extracted by mini-css-extract-plugin
export var hide = "sibling-navigation-module--hide--DRzHR";
export var icon = "sibling-navigation-module--icon--QwDDD";
export var pageLabel = "sibling-navigation-module--pageLabel--Q7FEy";
export var separator = "sibling-navigation-module--separator--YsUos";
export var siblingNavigation = "sibling-navigation-module--siblingNavigation--c+3Os";
export var subnav = "sibling-navigation-module--subnav--heCbd";